import { render, staticRenderFns } from "./rewardSerialPackEdit.vue?vue&type=template&id=4a5e686e&scoped=true&"
import script from "./rewardSerialPackEdit.vue?vue&type=script&lang=js&"
export * from "./rewardSerialPackEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e686e",
  null
  
)

export default component.exports